/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".child-header-container[_ngcontent-%COMP%]{margin-top:2.5rem;margin-bottom:1.5rem}.title[_ngcontent-%COMP%]{color:#0080ff;font-size:1.8rem;font-weight:700;margin-bottom:0}@media (max-width:767px){.child-header-container[_ngcontent-%COMP%]{margin-top:2.5rem}.no-margin-top[_ngcontent-%COMP%]{margin:1rem}}@media (max-width:575px){.child-header-container[_ngcontent-%COMP%]{margin-top:1rem}}.switch-container[_ngcontent-%COMP%]{margin-top:2.5rem;display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between}"];
export { styles as styles };
//# sourceMappingURL=study-bundle-child-header.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/study-bundle-child-header/study-bundle-child-header.component.scss.shim.ngstyle.js
// module id = 1403
// module chunks = 26 27 28